import React from "react";
import { trackEvent } from "../../lib/analytics";

export default function NoticeBar() {
  return (
    <div className="notice-bar w-full text-xs sm:text-sm">
      <div className="max-w-7xl mx-auto px-4 py-2 flex items-center justify-center gap-3 text-center">
        <span className="tracking-wide uppercase font-medium">Cohort of 6 — October 2026 applications closing soon.</span>
        <a href="#apply" onClick={() => trackEvent("cta_click", { label: "notice_bar_apply", location: "notice_bar" })} className="underline underline-offset-4 hover:opacity-90">Apply now →</a>
      </div>
    </div>
  );
}
